import { Box } from '@mui/material';

const DrawerFormActions = ({
  summary,
  children,
  sx = {},
  summarySx = {},
  actionsSx = {},
}) => (
  <Box
    component="footer"
    sx={{
      display: 'flex',
      px: { xs: 1.5, md: 2.5 },
      py: 1.5,
      gap: 1.5,
      borderTop: '1px solid',
      borderColor: 'divider',
      backgroundColor: 'background.paper',
      alignItems: { xs: 'stretch', sm: 'center' },
      justifyContent: 'space-between',
      flexWrap: 'wrap',
      ...sx,
    }}
  >
    {summary && (
      <Box sx={{ minWidth: 0, flex: '1 1 320px', ...summarySx }}>
        {summary}
      </Box>
    )}
    <Box
      sx={{
        display: 'flex',
        gap: 1.25,
        justifyContent: 'flex-end',
        flexWrap: 'wrap',
        width: { xs: '100%', sm: 'auto' },
        ml: 'auto',
        '& .MuiButton-root': {
          height: 48,
          minWidth: { xs: '100%', sm: 150 },
        },
        ...actionsSx,
      }}
    >
      {children}
    </Box>
  </Box>
);

export default DrawerFormActions;
